import FunctionSetting from "./FunctionSetting";
import BasicSetting from "./BasicSetting";
import AdvanceSetting from "./AdvanceSetting";

function FormInput({type, ...props}) {
    const renderInputByType = (setting) => {
        switch (setting) {
            case 'FUNCTION_SETTING':
                return (
                    <FunctionSetting 
                        {...props} 
                        setIsEdit={props.setIsEdit}
                        lincenseKey={props.lincenseKey}
                        setLincenseKey={props.setLincenseKey}
                        setIsChangeLincenseKey={props.setIsChangeLincenseKey}
                        isRootSetting={props.isRootSetting}
                        setBasicAIPrompt={props.setBasicAIPrompt}
                        setIsLoading={props.setIsLoading}
                        basicAIPrompt={props.basicAIPrompt}
                        licenseKeyDefault={{...props}.licenseKeyDefault}
                    />
                );
            case 'BASIC_SETTING':
                return (
                    <BasicSetting {...props} setIsEdit={props.setIsEdit}/>
                );
            case 'ADVANCE_SETTING':
                return (
                    <AdvanceSetting {...props} setIsEdit={props.setIsEdit}/>
                );
            default:
                return <p></p>
        }
    }
    return ( <>{renderInputByType(type)}</> );
}

export default FormInput;